import { defineComponent as _defineComponent } from 'vue'
import { usePrintable } from "@/hooks/usePrintable"


export default /*#__PURE__*/_defineComponent({
  __name: 'PrintableV2',
  props: {
    name: null,
    showFooter: { type: Boolean },
    vShow: { type: Boolean, default: true }
  },
  setup(__props: any, { expose }) {

const props = __props as { name: string, showFooter?: boolean, vShow: boolean }



const { generatePDF } = usePrintable()

const printPage = () => {
  generatePDF({ elementId: "print-page", fileName: props.name })
}

expose({
  printPage,
})

return { __sfc: true,props, generatePDF, printPage }
}

})